var $name="shell/registry/ComponentUnit",$path="app/modules/shell/registry/ComponentUnit.js",$this={$name,$path,};import ComponentContext from './ComponentContext';
import VisualUnit from './VisualUnit';

export default class Component extends VisualUnit {
  constructor(source, callback) {
    super(source, callback);
    super.createContext(ComponentContext, this);
  }
}
